export interface VehicleBcmDto {
  frontLeftDoorOpened?: boolean;
  frontRightDoorOpened?: boolean;
  hoodStateOpened?: boolean;
  cabinFan?: number;
  cabinSetTemperature?: number;
  cabinIntakeType?: number;
  handbrakeEngaged?: boolean;
  headlightsEngaged?: boolean;
  truckLocked?: boolean;
  ignitionEnabled?: boolean;
  errorsNumber?: number;
}
